import { ICoursePayload } from "../../types";
import { request } from "../../utils/axios";

export const fetchCourses = async (page = 1) => {
  try {
    const res = await request.get(`admin/courses?page=${page}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const createCourse = async (form: ICoursePayload, file?: any) => {
  try {
    const fd = new FormData();
    fd.append("image", file || form.image);
    fd.append("title", form.title);
    fd.append("category", form.category);
    fd.append("description", form.description);
    fd.append("objectives", form.objectives);
    fd.append("price", String(form.price || 0));
    fd.append("is_public", String(form.is_public));
    fd.append("tags", String(form.tags || ""));
    fd.append("currency", form.currency || "NGN");
    const res = await request.post(`admin/courses`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const updateCourse = async (form: ICoursePayload) => {
  try {
    const fd = new FormData();
    fd.append("image", form.image);
    fd.append("title", form.title);
    fd.append("category", form.category);
    fd.append("description", form.description);
    fd.append("objectives", form.objectives);
    fd.append("price", String(form.price));
    fd.append("is_public", String(form.is_public));
    fd.append("tags", String(form.tags));
    fd.append("currency", form.currency);
    const res = await request.put(`admin/courses/${form.ID}`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const publishCourse = async ({
  id,
  type,
}: {
  id: number | string;
  type: "published" | "draft" | "archived";
}) => {
  try {
    const res = await request.put(`admin/courses/${id}/status`, {
      status: type,
    });
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data?.error?.message || error?.response?.data?.error || "An error occurred";
    throw err;
  }
};

export const fetchSingleCourse = async (id: string | number) => {
  try {
    const res = await request.get(`admin/courses/${id}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const deleteCourse = async (id: string | number) => {
  try {
    const res = await request.delete(`admin/courses/${id}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data?.error || "An error occurred";
    throw err;
  }
};
